import { useQueryClient } from "@tanstack/react-query"
import { useMemo } from "react"

import { type FCC } from "@forento/ui/types/react"

import { query } from "~/utilities/trpc"

import UserContext from "."

const UserProvider: FCC = ({ children }) => {
	const queryClient = useQueryClient()
	const { data, isPending, refetch } = query.me.useQuery()

	const value = useMemo(
		() => ({
			isLoading: isPending,
			user: data ?? null,
			async reload(options?: { clearSessionCache?: boolean }) {
				if (options?.clearSessionCache) queryClient.removeQueries({ type: "inactive" })
				return refetch()
			},
		}),
		[data, isPending, queryClient, refetch],
	)

	return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

export default UserProvider
